<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="600px"
        title="编辑会议室"
    >
        <div class="container">
            <el-form
                ref="editForm"
                :rules="rules"
                :model="editForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="会议室名称"
                            size="small"
                            prop="name"
                        >
                            <el-input
                                clearable
                                placeholder="请输入会议室名称"
                                size="small"
                                v-model="editForm.name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="会议室说明"
                            size="small"
                            prop="desc"
                        >
                            <el-input
                                type="textarea"
                                clearable
                                placeholder="请输入会议室说明"
                                size="small"
                                v-model="editForm.desc"
                                :autosize="{ minRows: 4, maxRows: 6 }"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
export default {
    data() {
        return {
            editForm: {
                name: "",
                desc: ""
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入会议室名称",
                        trigger: "blur"
                    }
                ],
                desc: [
                    {
                        required: false,
                        message: "请输入会议室说明",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    props: {
        editVisible: Boolean,
        cellItem: Object
    },
    watch: {
        editVisible: {
            handler(newValue) {
                if (newValue) {
                    this.meetingLookUpRoom();
                }
            }
        }
    },
    created() {},
    methods: {
        /**
         * 保存
         */
        save() {
            this.$refs["editForm"].validate(valid => {
                if (valid) {
                    oaApi
                        .meetingRoom(
                            { ...this.editForm, id: this.cellItem.id },
                            "put"
                        )
                        .then(res => {
                            if (res) {
                                this.$parent.meetingRoom();
                                this.closeDialog();
                                this.$message.success("编辑成功!");
                            }
                        });
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:editVisible", false);
            this.$refs["editForm"].resetFields();
            this.$refs["editForm"].clearValidate();
        },
        meetingLookUpRoom() {
            oaApi
                .meetingLookUpRoom({ id: this.cellItem.id }, "get")
                .then(res => {
                    if (res.code == 200) {
                        for (let key in this.editForm) {
                            this.editForm[key] = res.data[key];
                        }
                    }
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.edit {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
    }
}
</style>
